module.exports = __webpack_public_path__ + "img/parent_test_btn.fcd9f85c.svg";